/** Todos os guias, na ordem da linha de cuidado (D-063). */
import type { Guia } from '../tipos';
import { guiaAcesso } from './acesso';
import { guiaAgenda, guiaNotificacoes, guiaPuericultura } from './acompanhamento';
import { guiaAdministracao, guiaSuperadmin } from './administracao';
import { guiaCadastro, guiaGestacao } from './cadastro';
import { guiaIndicadores, guiaTitular } from './gestao';
import { guiaMaternidade, guiaRecemNascido } from './maternidade';
import { guiaExames, guiaTratamento } from './prenatal';

export const GUIAS: Guia[] = [
  guiaAcesso,
  guiaCadastro,
  guiaGestacao,
  guiaExames,
  guiaTratamento,
  guiaMaternidade,
  guiaRecemNascido,
  guiaPuericultura,
  guiaNotificacoes,
  guiaAgenda,
  guiaIndicadores,
  guiaTitular,
  guiaAdministracao,
  guiaSuperadmin,
];

export const guiaPorId = (id: string | undefined) => GUIAS.find((g) => g.id === id);

/** "guia#secao" → guia e seção (D-065: o teste confere que toda referência existe). */
export function lerReferencia(referencia: string) {
  const [id, secaoId] = referencia.split('#');
  const guia = guiaPorId(id);
  const secao = guia?.secoes.find((s) => s.id === secaoId) ?? guia?.secoes[0];
  return guia && secao ? { guia, secao } : null;
}
